import styled from 'styled-components';
import JobDetail from './JobDetail';
import { media, colorSchema } from 'utils/style';

export default styled(JobDetail)`
  height: 100%;
  .job-detail {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(14, 1fr);
    flex-direction: column;
    height: 100%;

    &__body {
      display: flex;
      flex-grow: 1;
      flex-shrink: 1;
      grid-column: 4 / span 11;
      grid-row: 1;
    }

    &__header {
      display: flex;
      flex-wrap: wrap;
      padding: 1.6rem 2rem;
    }

    &__header-top {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    &__id-container {
      display: flex;
    }

    &__id {
      margin: 0;
      margin-bottom: 2.4rem;
    }

    &__status {
      margin-left: 2rem;
    }

    &__header-details {
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      ${media.greaterThan('tablet')`

        & > div:nth-child(1) {
          flex-basis: 50%;
        }

        & > div:nth-child(2) {
          flex-basis: 30%;
        }

        & > div:nth-child(3) {
          flex-basis: 20%;
        }
      `}
    }

    &__body {
      display: flex;
      width: 100%;
    }

    &__loading {
      display: flex;
      grid-column: 1 / span 14;
      grid-row: 1;
      margin: 2rem 0;
      justify-content: center;
      width: 100%;
    }

    &__error {
      color: ${colorSchema('error700')};
      display: flex;
      grid-column: 1 / span 14;
      grid-row: 1;
      margin: 2rem 0;
      justify-content: center;
    }

    &__side-block {
      margin: 1.6rem 0;
    }
  }
`;
